import React from 'react';
import LoginForm from './LoginForm.js';
import AuthCard, { AuthLink } from '../auth-shared/AuthCard.js';
import { getBrandName } from '../auth-shared/brandName.js';
import './login-v2.css';

/**
 * LoginPage — mounted at the existing `/authorization/` URL. Wraps the shared
 * `LoginForm` in this page's own chrome; the plan-purchase page embeds the
 * same form without it.
 */
export default function LoginPage() {
	return (
		<div className="auth-v2">
			<AuthCard
				title="Sign in"
				subtitle={`Welcome back to ${getBrandName()}.`}
				footer={
					<>
						<p className="m-0">
							<AuthLink href="/authorization/recovery/">Forgot your password?</AuthLink>
						</p>
						<p className="m-0">
							New here? <AuthLink href="/authorization/registration/">Create an account</AuthLink>
						</p>
					</>
				}
			>
				<LoginForm />
			</AuthCard>
		</div>
	);
}
